module.exports = __webpack_public_path__ + "img/img_03_retail@3x.8e1cbb30.png";